import { Box, Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";

export const SectionContainer = styling("div")((props) => ({
  maxWidth: "1240px",
  margin: "0 auto",
  // padding: "3.125rem 6.25rem",
  position: "relative",
  top: "-6.5rem",
  height: "0px",
  marginBottom: "200px",

  [props.theme.breakpoints.down("lg")]: {
    padding: "0px 24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "0px 24px",
    top: "-1.5rem",
    marginBottom: "400px",
  },
}));

export const CardStyled = styling("div")((props) => ({
  width: "100%",
  maxWidth: "1240px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  border: "2px solid #FFF",
  background:
    "linear-gradient(93deg, #F5F2FC 0%, #E4DEF8 23.72%, #CCC0F2 58.18%, #512ACC 106.6%)",
  borderRadius: "16px",
  padding: "32px 40px",

  [props.theme.breakpoints.down("lg")]: {
    padding: "32px 28px",
    flexDirection: "column",
    justifyContent: "center",
    gap: "24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "32px 24px",
  },
}));

export const BoxStyled = styling(Box)({});

export const TextStyled = styling(Typography)((props) => ({}));

export const ButtonStyled = styling(Button)((props) => ({
  display: "flex",
  minWidth: "240px",
  width: "fit-content",
  padding: "12px 24px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  textTransform: "capitalize",
  border: " 1px solid rgba(255, 200, 60, 0.40)",
  background: "linear-gradient(180deg, #FD5 50%, #FFB800 122.92%)",
  boxShadow:
    "0 -1px 4px 0 rgba(255, 255, 255, 0.00) inset, 0 4px 16px 0 rgba(0, 0, 0, 0.40)",
  color: "rgba(0, 0, 0, 0.87)",
  textAlign: "center",
  borderRadius: "10px",
  height: "54px",
  fontSize: "20px",
  fontWeight: "700",
  lineHeight: "30px",
  letterSpacing: "0.1px",

  ":hover": {
    backgroundColor: "#FFDE24",
  },

  [props.theme.breakpoints.down("lg")]: {
    height: "48px",
    padding: "12px 24px",
    fontSize: "16px",
    lineHeight: "24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));
